export default __webpack_public_path__ + "static/media/flag.5b711750.svg";